import { Accordion, Box, Heading } from '@chakra-ui/react';
import React from 'react';
import FaqQuestion, { FaqQuestionType } from '../FaqQuestion';

export type FaqCategoryType = {
  id: string;
  title: string;
  questions: FaqQuestionType[];
};

const FaqCategory = ({ questions, title }: FaqCategoryType) => (
  <Box>
    <Heading mb={16} as="h2" fontSize={[`2xl`, null, `3xl`, `4xl`]}>
      {title}
    </Heading>
    <Accordion allowToggle>
      {questions.map((item) => (
        <FaqQuestion key={item.title} answer={item.answer} title={item.title} />
      ))}
    </Accordion>
  </Box>
);

export default FaqCategory;
